// import React, { useEffect, useRef } from "react";
// import Bride from "../assets/images/mymy.jpg";
// import Groom from "../assets/images/vuong.jpg";
// import "./Bridegroom.css";

// function Bridegroom() {
//   const sectionRef = useRef(null);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             // Khi component xuất hiện trong viewport
//             entry.target.classList.add("visible");

//             // Reset animation bằng cách xóa và thêm lại class
//             const animatedElements = entry.target.querySelectorAll(
//               ".text-animate, .img"
//             );
//             animatedElements.forEach((el) => {
//               el.classList.remove("animate-active");
//               void el.offsetWidth; // Trigger reflow
//               el.classList.add("animate-active");
//             });
//           } else {
//             // Khi component ra khỏi viewport
//             entry.target.classList.remove("visible");
//           }
//         });
//       },
//       {
//         threshold: 0.1, // Khi 10% component xuất hiện
//         rootMargin: "0px 0px -50px 0px", // Trigger sớm hơn một chút
//       }
//     );

//     const currentRef = sectionRef.current;
//     if (currentRef) {
//       observer.observe(currentRef);
//     }

//     // Cleanup observer khi component unmount
//     return () => {
//       if (currentRef) {
//         observer.unobserve(currentRef);
//       }
//     };
//   }, []);

//   return (
//     <div
//       id="couple"
//       className="bridegroom clear section-padding bg-pink"
//       ref={sectionRef}
//     >
//       <div className="container">
//         <div className="row mb-60">
//           <div className="col-md-6">
//             <div
//               className="item toright mb-30 animate-box bride-item"
//               data-animate-effect="fadeInLeft"
//             >
//               <div className="img">
//                 <img src={Bride} alt="Nguyễn Thị Thẩm Mỹ" />
//               </div>
//               <div className="info valign">
//                 <div className="full-width">
//                   <h6 className="text-animate">
//                     Nguyễn Thị Thẩm Mỹ <i className="ti-heart"></i>
//                   </h6>
//                   <span className="text-animate">Trưởng nữ</span>
//                   <p className="text-animate">
//                     Nhà ở 12/127, khu vực Thới Bình A, Phường Thới An, Quận Ô
//                     Môn, Thành Phố Cần Thơ. <br />
//                     Cha: Nguyễn Thanh Tiến <br />
//                     Mẹ: Lê Thị Anh Kiều
//                   </p>
//                   <div className="social text-animate">
//                     <div className="full-width">
//                       <a href="#0" className="icon">
//                         <i className="ti-facebook"></i>
//                       </a>
//                       <a href="#0" className="icon">
//                         <i className="ti-twitter"></i>
//                       </a>
//                       <a href="#0" className="icon">
//                         <i className="ti-instagram"></i>
//                       </a>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="col-md-6">
//             <div
//               className="item mb-30 animate-box groom-item"
//               data-animate-effect="fadeInRight"
//             >
//               <div className="img">
//                 <img src={Groom} alt="Nguyễn Nhật Vương" />
//               </div>
//               <div className="info valign">
//                 <div className="full-width">
//                   <h6 className="text-animate">
//                     Nguyễn Nhật Vương <i className="ti-heart"></i>
//                   </h6>
//                   <span className="text-animate">Út nam</span>
//                   <p className="text-animate">
//                     Nhà ở 344/9, khu vực Bình Hưng, Phường Phước Thới, Quận Ô
//                     Môn, Thành Phố Cần Thơ <br />
//                     Mẹ: Nguyễn Thị Năm
//                   </p>
//                   <div className="social text-animate">
//                     <div className="full-width">
//                       <a href="#0" className="icon">
//                         <i className="ti-facebook"></i>
//                       </a>
//                       <a href="#0" className="icon">
//                         <i className="ti-twitter"></i>
//                       </a>
//                       <a href="#0" className="icon">
//                         <i className="ti-instagram"></i>
//                       </a>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="row">
//           <div
//             className="col-md-12 text-center animate-box title-section"
//             data-animate-effect="fadeInUp"
//           >
//             <h3 className="oliven-couple-title text-animate">
//               Trân trọng kính mời
//             </h3>
//             <h4 className="oliven-couple-subtitle text-animate">
//               Ngày 5 Tháng 4 Năm 2025 — Ô Môn, Cần Thơ <br />( Tại tư gia )
//             </h4>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Bridegroom;

import React, { useEffect, useRef, useState } from "react";
import Bride from "../assets/images/mymy.jpg";
import Groom from "../assets/images/vuong.jpg";
import "./Bridegroom.css";

function Bridegroom() {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [floatingHearts, setFloatingHearts] = useState([]);

  // Hiệu ứng chuyển động trái tim ngẫu nhiên
  useEffect(() => {
    if (isVisible) {
      const heartInterval = setInterval(() => {
        // Tạo trái tim mới với vị trí ngẫu nhiên
        const newHeart = {
          id: Date.now(),
          left: Math.random() * 100,
          delay: Math.random() * 2,
          size: 10 + Math.random() * 20,
          duration: 4 + Math.random() * 3,
        };

        setFloatingHearts((prevHearts) => [...prevHearts, newHeart]);

        // Xóa trái tim cũ sau khi kết thúc hiệu ứng
        setTimeout(() => {
          setFloatingHearts((prevHearts) =>
            prevHearts.filter((heart) => heart.id !== newHeart.id)
          );
        }, newHeart.duration * 1000);
      }, 500);

      return () => clearInterval(heartInterval);
    }
  }, [isVisible]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Khi component xuất hiện trong viewport
            entry.target.classList.add("visible");
            setIsVisible(true);

            // Reset animation bằng cách xóa và thêm lại class
            const animatedElements = entry.target.querySelectorAll(
              ".text-animate, .img, .couple-item"
            );
            animatedElements.forEach((el) => {
              el.classList.remove("animate-active");
              void el.offsetWidth; // Trigger reflow
              el.classList.add("animate-active");
            });
          } else {
            // Khi component ra khỏi viewport
            entry.target.classList.remove("visible");
            setIsVisible(false);
          }
        });
      },
      {
        threshold: 0.1, // Khi 10% component xuất hiện
        rootMargin: "0px 0px -50px 0px", // Trigger sớm hơn một chút
      }
    );

    const currentRef = sectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    // Cleanup observer khi component unmount
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <div
      id="couple"
      className="wedding-couple-section bg-gradient"
      ref={sectionRef}
    >
      {/* Floating hearts animation */}
      <div className="floating-hearts-container">
        {floatingHearts.map((heart) => (
          <div
            key={heart.id}
            className="floating-heart"
            style={{
              left: `${heart.left}%`,
              animationDelay: `${heart.delay}s`,
              fontSize: `${heart.size}px`,
              animationDuration: `${heart.duration}s`,
            }}
          >
            ❤️
          </div>
        ))}
      </div>

      {/* Decorative elements */}
      <div className="decorative-corner top-left"></div>
      <div className="decorative-corner top-right"></div>
      <div className="decorative-corner bottom-left"></div>
      <div className="decorative-corner bottom-right"></div>

      <div className="container">
        <div className="section-heading">
          <div className="rings-icon">
            <svg viewBox="0 0 100 50" className="wedding-rings">
              <circle
                cx="30"
                cy="25"
                r="18"
                fill="none"
                stroke="#d4af37"
                strokeWidth="3"
              />
              <circle
                cx="70"
                cy="25"
                r="18"
                fill="none"
                stroke="#d4af37"
                strokeWidth="3"
              />
            </svg>
          </div>
          <h2 className="wedding-title">Cô dâu & Chú rể</h2>
          <div className="title-divider">
            <span className="line"></span>
            <span className="heart-icon">💕</span>
            <span className="line"></span>
          </div>
        </div>

        <div className="row couple-row">
          <div className="col-md-6">
            <div className="couple-item bride-item">
              <div className="profile-frame">
                <div className="img-container">
                  <img
                    src={Bride}
                    alt="Nguyễn Thị Thẩm Mỹ"
                    className="profile-img"
                  />
                  <div className="img-overlay"></div>
                </div>
              </div>

              <div className="profile-info">
                <div className="name-with-heart">
                  <h3 className="text-animate">Nguyễn Thị Thẩm Mỹ</h3>
                  <span className="heart-divider">💖</span>
                </div>
                <p className="family-title text-animate">Trưởng nữ</p>
                <div className="text-animate address-info">
                  <div className="info-icon-wrapper">
                    <i className="fas fa-home info-icon"></i>
                    <p>
                      12/127, khu vực Thới Bình A, Phường Thới An, Quận Ô Môn,
                      Thành Phố Cần Thơ.
                    </p>
                  </div>
                  <div className="parents-info">
                    <div className="info-icon-wrapper">
                      <i className="fas fa-male info-icon"></i>
                      <p>Cha: Nguyễn Thanh Tiến</p>
                    </div>
                    <div className="info-icon-wrapper">
                      <i className="fas fa-female info-icon"></i>
                      <p>Mẹ: Lê Thị Anh Kiều</p>
                    </div>
                  </div>
                </div>
                <div className="social-icons text-animate">
                  <a href="#0" className="social-link" aria-label="Facebook">
                    <i className="fab fa-facebook"></i>
                  </a>
                  <a href="#0" className="social-link" aria-label="Instagram">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a href="#0" className="social-link" aria-label="Twitter">
                    <i className="fab fa-twitter"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="connecting-symbol">
            <div className="symbol-container">
              <div className="flower-divider top"></div>
              <div className="ampersand">&</div>
              <div className="flower-divider bottom"></div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="couple-item groom-item">
              <div className="profile-frame">
                <div className="img-container">
                  <img
                    src={Groom}
                    alt="Nguyễn Nhật Vương"
                    className="profile-img"
                  />
                  <div className="img-overlay"></div>
                </div>
              </div>

              <div className="profile-info">
                <div className="name-with-heart">
                  <h3 className="text-animate">Nguyễn Nhật Vương</h3>
                  <span className="heart-divider">💖</span>
                </div>
                <p className="family-title text-animate">Út nam</p>
                <div className="text-animate address-info">
                  <div className="info-icon-wrapper">
                    <i className="fas fa-home info-icon"></i>
                    <p>
                      344/9, khu vực Bình Hưng, Phường Phước Thới, Quận Ô Môn,
                      Thành Phố Cần Thơ
                    </p>
                  </div>
                  <div className="parents-info">
                    <div className="info-icon-wrapper">
                      <i className="fas fa-female info-icon"></i>
                      <p>Mẹ: Nguyễn Thị Năm</p>
                    </div>
                  </div>
                </div>
                <div className="social-icons text-animate">
                  <a href="#0" className="social-link" aria-label="Facebook">
                    <i className="fab fa-facebook"></i>
                  </a>
                  <a href="#0" className="social-link" aria-label="Instagram">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a href="#0" className="social-link" aria-label="Twitter">
                    <i className="fab fa-twitter"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="invitation-section">
          <div className="invitation-card">
            <div className="invitation-header">
              <div className="invitation-icon">
                <i className="fas fa-envelope-open-text"></i>
              </div>
              <h3 className="invitation-title text-animate">
                Trân trọng kính mời
              </h3>
            </div>
            <div className="invitation-details">
              <div className="detail-row">
                <div className="detail-icon">
                  <i className="fas fa-calendar-alt"></i>
                </div>
                <div className="detail-text">Ngày 5 Tháng 4 Năm 2025</div>
              </div>
              <div className="detail-row">
                <div className="detail-icon">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <div className="detail-text">Ô Môn, Cần Thơ (Tại tư gia)</div>
              </div>
            </div>
            <div className="invitation-footer">
              <div className="flower-divider"></div>
              <p className="footer-text">
                Sự hiện diện của quý vị là niềm vinh hạnh của chúng tôi
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Bridegroom;
